<template>
  <div class="container my-32">
    <ClientOnly>
      <div
        :id="id"
        ref="wrapper"
        class="overflow-hidden rounded-large bg-white shadow"
      >
        <div v-if="isEditing" class="ck-content p-32">
          <h3>mailXpert</h3>
          <div v-if="!isValid" class="text-red-500">
            Eingegebene URL ist ungültig. Die URL muss den String /de/
            enthalten.
          </div>
          <p>
            <strong>{{ options.mailxpertSource }}</strong>
          </p>
          <p>
            Das Fomular wird während dem Editieren nicht angezeigt.<br />
            Mit «Responsive Vorschau» kann eine Vorschau des Formulars angezeigt
            werden.
          </p>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
const { options, uuid } = defineBlokkliFragment({
  name: 'mailxpert',
  label: 'mailXpert',
  description: 'Zeigt das Formular für die mailXpert Newsletter-Anmeldung an.',
  options: {
    mailxpertSource: {
      type: 'text',
      label: 'src',
      default:
        'https://nl.mailxpert.ch/e/e2737e1b96ab0a58/de/form/bdd5e8df-da11-4551-8718-34cf15981092.html?render=container',
    },
  },
  editor: {
    noPreview: true,
  },
})
const isEditing = false

const language = useCurrentLanguage()

const id = computed(() => 'mailxpert-' + uuid)

const wrapper = ref<HTMLDivElement | null>(null)

const isValid = computed(() =>
  (options.value.mailxpertSource || '').includes('/de/'),
)

const src = computed(() => {
  const source = options.value.mailxpertSource
  if (typeof source !== 'string') {
    return
  }

  return source.replace('/de/', `/${language.value}/`)
})

const script = useScript({
  src: 'https://api.mailxpert.ch/forms.js',
  crossorigin: false,
})

onMounted(() => {
  if (isEditing || !src.value) {
    return
  }
  script
    .load()
    .then(() => {
      try {
        // @ts-ignore
        const mailxpert = window.mailxpert

        if (!mailxpert || !wrapper.value || !options.value.mailxpertSource) {
          return
        }

        mailxpert.forms.include({
          src: src.value,
          element: wrapper.value,
          type: 'subscription_form',
        })
      } catch {
        // Noop.
      }
    })
    .catch()
})
</script>
